import { DragOverlay } from "@dnd-kit/core";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  DragTypeStationEnum,
  stationRouteDraggingDataAtom,
} from "@ryde/shared";

import { StationRouteStation } from "./station-route.station";

export const StationRouteDragOverlay: FC = () => {
  const stationRouteDraggingData = useRecoilValue(stationRouteDraggingDataAtom);
  const { type: dragType, payload: props } = stationRouteDraggingData;
  return (
    dragType === DragTypeStationEnum.STATION && (
      <DragOverlay
        dropAnimation={null}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
      >
        <StationRouteStation
          key={props.station.id}
          station={props.station}
          stationRouteDto={props.stationRouteDto}
          isLastStation={false}
          isFirstStation={false}
          stationIndex={props.stationIndex}
          isDragClone={true}
        />
      </DragOverlay>
    )
  );
};
